import React from 'react';
import { Route } from 'react-router-dom';

const FinanceDashboard = React.lazy(() => import('../pages/finance/FinanceDashboard'));
const Invoices = React.lazy(() => import('../pages/finance/Invoices'));
const Payments = React.lazy(() => import('../pages/finance/Payments'));
const FinanceReports = React.lazy(() => import('../pages/finance/Reports'));
const Receivables = React.lazy(() => import('../pages/finance/Receivables'));
const Expenses = React.lazy(() => import('../pages/finance/Expenses'));
const CashBank = React.lazy(() => import('../pages/finance/CashBank'));
const Revenue = React.lazy(() => import('../pages/finance/Revenue'));
const FinancePayroll = React.lazy(() => import('../pages/finance/FinancePayroll'));
const ReimbursementManagement = React.lazy(() => import('../pages/finance/ReimbursementManagement'));
const TaxReports = React.lazy(() => import('../pages/finance/taxes/TaxReports'));
const CashbackRecap = React.lazy(() => import('../pages/marketing/CashbackRecap'));

export const getFinanceRoutes = () => [
  <Route key="finance-dashboard" path="/finance" element={<FinanceDashboard />} />,
  <Route key="finance-dashboard-sub" path="/finance/dashboard" element={<FinanceDashboard />} />,
  <Route key="finance-invoices" path="/finance/invoices" element={<Invoices />} />,
  <Route key="finance-payments" path="/finance/payments" element={<Payments />} />,
  <Route key="finance-reports" path="/finance/reports" element={<FinanceReports />} />,
  <Route key="finance-receivables" path="/finance/receivables" element={<Receivables />} />,
  <Route key="finance-expenses" path="/finance/expenses" element={<Expenses />} />,
  <Route key="finance-cash-bank" path="/finance/cash-bank" element={<CashBank />} />,
  <Route key="finance-payroll" path="/finance/payroll" element={<FinancePayroll />} />,
  <Route key="finance-revenue" path="/finance/revenue" element={<Revenue />} />,
  <Route key="finance-reimbursement" path="/finance/reimbursement" element={<ReimbursementManagement />} />,
  <Route key="finance-taxes" path="/finance/taxes" element={<TaxReports />} />,
  <Route key="finance-cashback" path="/finance/cashback" element={<CashbackRecap />} />
];
